/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminCreateRequest } from '../backend/model';
// @ts-ignore
import type { ApiResponseAdminDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseListAdminAuditLogDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseListAdminDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseVoid } from '../backend/model';
// @ts-ignore
import type { UpdateAdminRequest } from '../backend/model';
/**
 * AdminManagementApi - axios parameter creator
 * @export
 */
export const AdminManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new admin user with specified council and role
         * @summary Create a new admin
         * @param {AdminCreateRequest} adminCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmin: async (adminCreateRequest: AdminCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCreateRequest' is not null or undefined
            assertParamExists('createAdmin', 'adminCreateRequest', adminCreateRequest)
            const localVarPath = `/api/admins/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an admin user from the system
         * @summary Delete an admin
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmin: async (adminId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('deleteAdmin', 'adminId', adminId)
            const localVarPath = `/api/admins/{adminId}`
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed information for an admin user
         * @summary Get admin details
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmin: async (adminId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('getAdmin', 'adminId', adminId)
            const localVarPath = `/api/admins/{adminId}`
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve audit log entries for an admin user
         * @summary Get admin audit logs
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminAuditLogs: async (adminId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('getAdminAuditLogs', 'adminId', adminId)
            const localVarPath = `/api/admins/{adminId}/audit-logs`
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of all admin users in the system
         * @summary Get all admins
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmins: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admins/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing admin user\'s information
         * @summary Update an admin
         * @param {string} adminId 
         * @param {UpdateAdminRequest} updateAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdmin: async (adminId: string, updateAdminRequest: UpdateAdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('updateAdmin', 'adminId', adminId)
            // verify required parameter 'updateAdminRequest' is not null or undefined
            assertParamExists('updateAdmin', 'updateAdminRequest', updateAdminRequest)
            const localVarPath = `/api/admins/{adminId}`
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminManagementApi - functional programming interface
 * @export
 */
export const AdminManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new admin user with specified council and role
         * @summary Create a new admin
         * @param {AdminCreateRequest} adminCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdmin(adminCreateRequest: AdminCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseAdminDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdmin(adminCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminManagementApi.createAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an admin user from the system
         * @summary Delete an admin
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdmin(adminId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseVoid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdmin(adminId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminManagementApi.deleteAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed information for an admin user
         * @summary Get admin details
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdmin(adminId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseAdminDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdmin(adminId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminManagementApi.getAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve audit log entries for an admin user
         * @summary Get admin audit logs
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminAuditLogs(adminId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListAdminAuditLogDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminAuditLogs(adminId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminManagementApi.getAdminAuditLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of all admin users in the system
         * @summary Get all admins
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdmins(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListAdminDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdmins(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminManagementApi.getAdmins']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing admin user\'s information
         * @summary Update an admin
         * @param {string} adminId 
         * @param {UpdateAdminRequest} updateAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdmin(adminId: string, updateAdminRequest: UpdateAdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseAdminDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdmin(adminId, updateAdminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminManagementApi.updateAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminManagementApi - factory interface
 * @export
 */
export const AdminManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminManagementApiFp(configuration)
    return {
        /**
         * Create a new admin user with specified council and role
         * @summary Create a new admin
         * @param {AdminCreateRequest} adminCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmin(adminCreateRequest: AdminCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseAdminDTO> {
            return localVarFp.createAdmin(adminCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an admin user from the system
         * @summary Delete an admin
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmin(adminId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseVoid> {
            return localVarFp.deleteAdmin(adminId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed information for an admin user
         * @summary Get admin details
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmin(adminId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseAdminDTO> {
            return localVarFp.getAdmin(adminId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve audit log entries for an admin user
         * @summary Get admin audit logs
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminAuditLogs(adminId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListAdminAuditLogDTO> {
            return localVarFp.getAdminAuditLogs(adminId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of all admin users in the system
         * @summary Get all admins
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmins(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListAdminDTO> {
            return localVarFp.getAdmins(options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing admin user\'s information
         * @summary Update an admin
         * @param {string} adminId 
         * @param {UpdateAdminRequest} updateAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdmin(adminId: string, updateAdminRequest: UpdateAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseAdminDTO> {
            return localVarFp.updateAdmin(adminId, updateAdminRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminManagementApi - object-oriented interface
 * @export
 * @class AdminManagementApi
 * @extends {BaseAPI}
 */
export class AdminManagementApi extends BaseAPI {
    /**
     * Create a new admin user with specified council and role
     * @summary Create a new admin
     * @param {AdminCreateRequest} adminCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminManagementApi
     */
    public createAdmin(adminCreateRequest: AdminCreateRequest, options?: RawAxiosRequestConfig) {
        return AdminManagementApiFp(this.configuration).createAdmin(adminCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an admin user from the system
     * @summary Delete an admin
     * @param {string} adminId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminManagementApi
     */
    public deleteAdmin(adminId: string, options?: RawAxiosRequestConfig) {
        return AdminManagementApiFp(this.configuration).deleteAdmin(adminId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed information for an admin user
     * @summary Get admin details
     * @param {string} adminId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminManagementApi
     */
    public getAdmin(adminId: string, options?: RawAxiosRequestConfig) {
        return AdminManagementApiFp(this.configuration).getAdmin(adminId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve audit log entries for an admin user
     * @summary Get admin audit logs
     * @param {string} adminId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminManagementApi
     */
    public getAdminAuditLogs(adminId: string, options?: RawAxiosRequestConfig) {
        return AdminManagementApiFp(this.configuration).getAdminAuditLogs(adminId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of all admin users in the system
     * @summary Get all admins
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminManagementApi
     */
    public getAdmins(options?: RawAxiosRequestConfig) {
        return AdminManagementApiFp(this.configuration).getAdmins(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing admin user\'s information
     * @summary Update an admin
     * @param {string} adminId 
     * @param {UpdateAdminRequest} updateAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminManagementApi
     */
    public updateAdmin(adminId: string, updateAdminRequest: UpdateAdminRequest, options?: RawAxiosRequestConfig) {
        return AdminManagementApiFp(this.configuration).updateAdmin(adminId, updateAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

